import React, { Component } from "react";
import { Link } from 'react-router-dom'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components'
import Card from 'react-bootstrap/Card'
import ListGroup from 'react-bootstrap/ListGroup'
import Button from 'react-bootstrap/Button'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import * as firebase from 'firebase';
import 'firebase/firestore'

import './generalScreens.css';


const StyledContainer = styled(Container)`
  padding-right:0;
  padding-left:0;
  margin-right:auto;
  margin-left:auto;
  overflow: hidden;
  position: relative;
  justifyContent: 'center';
`

const CardContainer = styled.div`
  padding: 1%;
`

const CardImg = styled(Card.Img)`
  
`

export default class Events extends Component {
  constructor(props) {
    super(props);


    this.state = {
      eventCards: [],    //used to display data
      eventData: [],     //will be used to push data to other screens
      refresh: true,    //used to ensure data automatically loads
    };
  }

  getEvents = async () => {
    this.setState({ refresh: true })
    firebase.firestore().collection("events").onSnapshot((ohSnap) => {

      let count = 0;

      ohSnap.forEach((doc) => {
        this.state.eventData.push(doc.data());


        let tmpObj =

          <CardContainer key={count}>
            {/* <Styles> */}
            <Card className="card" style={{ width: '18rem' }}>
              <CardImg variant="top"  style={{maxHeight: 375}} src={doc.data().eventFlyer} />
              <Card.Body>
                <Card.Title>{doc.data().eventName}</Card.Title>
              </Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroup.Item>${doc.data().eventPrice}</ListGroup.Item>
                <ListGroup.Item>{doc.data().eventDate + ' @ ' + doc.data().startTime}</ListGroup.Item>
                <ListGroup.Item>{doc.data().eventCity + ', ' + doc.data().eventState}</ListGroup.Item>
              </ListGroup>
              <Card.Body>
                <Link to={{
                  pathname: "/purchase",
                  state: {
                    allData: this.state.eventData[count],
                  }
                }}>
                  <Button className="button-tickets" variant="success">Buy Tickets</Button>
                </Link>
              </Card.Body>
            </Card>
            {/* </Styles> */}
          </CardContainer>;

        this.state.eventCards.push(tmpObj);

        count++;
      })

      if (this.state.eventCards.length === 0) {
        this.setState({ refresh: true });
      }
      else {
        this.setState({ refresh: false })
      }
    });
  };

  componentDidMount() {
    if (this.state.refresh === true) {
      this.setState({ eventCards: [] })
      this.getEvents();
      this.setState({ refresh: !this.state.refresh });
    }
  };

  render() {
    return (
      <StyledContainer>
        <Row style={{ justifyContent: 'center' }}>
          {this.state.eventCards}
        </Row>
      </StyledContainer>
    )
  }
}


